<template>
  <div id="app">
    <div v-if="availableParams.model.length === 0" class="loading-screen">
      <div class="load-icon"></div>
    </div>
    <FullscreenBlock v-if="fullscreenSlot" :slotv="fullscreenSlot" @close="fullscreenSlot = null"/>
    <Crs19View />
  </div>
</template>
<script>
import FullscreenBlock from '@/components/FullscreenBlock.vue'
import { mapGetters } from 'vuex'
import config from '@/configuration/config.js'
import Crs19View from '@/components/Crs19View.vue'

export default {
  name: 'app',
  components: {
    FullscreenBlock,
    Crs19View
  },
  data () {
    return {
      settingsVisible: false,
      fullscreenSlot: null,
      displayWelcomeScreen: true
    }
  },
  watch: {
    waitingParamsCorrect (newValue) {
      if (newValue.length === 0) return
      this.$store.commit('removeParamsFromWaitingList', newValue[0])
    },
    globalParams () {
      this.$store.dispatch('globalParamsUpdated')
    }
  },
  computed: {
    welcomeScreenVisible () { return this.displayWelcomeScreen && !this.isElementClosed('welcome-screen') },
    ...mapGetters(['visibleSlots', 'preview', 'isElementClosed', 'waitingParamsCorrect', 'waitingParamsConflicts', 'recentSessions', 'globalParams', 'availableParams'])
  },
  created () {
    console.log(BUILDINFO)

    // eslint-disable-next-line no-unused-expressions
    import('@/components/Plotly.vue')
    this.$store.dispatch('init').then(() => {
      let demo = '0'
      let dataURL = ''
      let sessionURL = ''
      let sessionUUID = ''
      if (demo) {
        try {
          let nr = Number.parseInt(demo)
          dataURL = config.examples[nr].url
          sessionURL = config.examples[nr].session
        } catch (e) {
          console.error('Failed to load demo', e)
        }
      }
      if (sessionURL) {
        this.$store.dispatch('loadSessionURL', sessionURL).catch(console.error)
        this.displayWelcomeScreen = false
      } else if (sessionUUID) {
        let session = this.recentSessions.find(s => s.uuid === sessionUUID)
        if (session) {
          this.$store.dispatch('importSession', session)
          this.displayWelcomeScreen = false
        }
      } else if (dataURL) {
        this.$store.dispatch('loadURL', dataURL).catch(console.error)
        this.displayWelcomeScreen = false
      }
    })
  }
}
</script>
<style>
@import "style.css";

#app {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  user-select: none;
}
#playground {
  position: absolute;
  top:64px;
  left: 0;
  width: 100%;
  height: calc(100% - 64px);
  background: url('assets/grid.png') repeat;
}
#app > .deletezone {
  position: absolute;
  bottom: -10px;
  left: 0;
  width: calc(100% - 10px);
}
#app > .sidepanel {
  height: calc(100% - 64px);
  position: absolute;
  z-index: 10000;
  top: 64px;
}
#app > div.overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100001;
}
#app > div.overlay-2 {
  z-index: 100003;
}
#app > div.loading-screen {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 100005;
}
#app > div.loading-screen > div.load-icon {
  width: 50px;
  height: 50px;
  border-left: 4px solid #371ea3;
  border-radius: 50%;
  left: calc(50% - 25px);
  top: calc(50% - 25px);
  position: absolute;
  transform-origin: 50% 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
